module.exports = __webpack_public_path__ + "static/img/case-1linye3D.85471a2a.jpg";